import React from 'react'
import { connect } from 'react-redux'
import TopBar from 'components/TopBar'
import MobileTopBar from 'components/MobileTopBar'
import SideBar from 'components/SideBar'
import BottomBar from 'components/BottomBar'
import Map from 'components/Map'
import Modal from 'components/Modal'
import Notification from 'components/Notification'
import handleMetaKeyInput from 'helpers/handleMetaKeyInput'
import isOverview from 'helpers/isOverview'
import MediaQuery from 'react-responsive'
import { MOBILE_BREAKPOINT_WIDTH } from 'helpers/globals'
import getCurrentCamera from 'helpers/cameras/getCurrentCamera'
import { zoomToSingleCameraAction } from 'actions/mapActions'
import equals from 'ramda/src/equals'

const mapStateToProps = ({ cameras, currentEntity, exportType, map: { ref, markups, floorPlans }, ui: { modal } }) => {
  const currentCamera = getCurrentCamera(cameras)
  return {
    currentCamera,
    currentEntity,
    cameraSelected: currentCamera && currentEntity.type === 'camera' && currentEntity.id === currentCamera.id,
    exportType,
    map: ref,
    currentLabel: currentEntity.type === 'label' && markups.find(m => m.id === currentEntity.id),
    currentFloorplan: currentEntity.type === 'floorPlan' && floorPlans.find(f => f.id === currentEntity.id),
    uploadingFloorPlan: !!modal && modal === 'MobileFloorPlanUploader'
  }
}

const initialState = { panel: null }

class Calculator extends React.Component {
  state = initialState

  constructor(props) {
    super(props)
    handleMetaKeyInput()
  }

  componentWillUpdate(nextProps) {
    if (this.state.panel !== null && this.state.panel !== 'cameraList' && !equals(nextProps.currentEntity, this.props.currentEntity)) {
      // have settings stay open when switching between cameras
      if (this.state.panel === 'editConfig' && nextProps.currentEntity.type === 'camera') {
        this.props.zoomToSingleCameraAction(nextProps.currentCamera)
      } else {
        this.setState(initialState)
      }
    }
  }

  setPanel = panel => _ => this.setState({ panel })

  openCameraPanel = key => _ => {
    this.setState({ panel: key })
    setTimeout(_ => { this.props.zoomToSingleCameraAction(this.props.currentCamera) }, 1)
  }

  close = _ => this.setState(initialState)

  openCameraList = _ => {
    this.setState({ panel: 'cameraList' }, _ => {
      google.maps.event.addListenerOnce(this.props.map, 'click', _ => {
        this.setState(initialState)
      })
    })
  }

  openLabel = _ => {
    this.setState({ panel: 'editLabel' })
    setTimeout(_ => this.props.map.fitBounds(this.props.currentLabel.overlay.rectangle.getBounds()), 1)
  }

  openFloorplan = _ => {
    this.setState({ panel: 'editFloorplan' })
    setTimeout(_ => this.props.map.fitBounds(this.props.currentFloorplan.overlay.getBounds()), 1)
  }

  render() {
    const { setPanel, openCameraPanel, close, openCameraList, openLabel, openFloorplan, props: { exportType, currentEntity, uploadingFloorPlan }, state: { panel } } = this
    const menuSelected = !!panel
    const forceMobile = menuSelected || uploadingFloorPlan
    const isNotOverview = !isOverview(exportType)

    return (
      <div className={EXPORT ? 'EXPORT' : ''}>
        <div style={{
          flex: '1 1 auto',
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          position: 'relative'
        }}>
          { isNotOverview && !(EXPORT && currentEntity.type !== 'camera') &&
            <MediaQuery minWidth={MOBILE_BREAKPOINT_WIDTH + 1}>
              { matches =>
                  matches && !forceMobile
                  ? <TopBar key='topbar' />
                  : <MobileTopBar key='mobiletopbar' { ...{ menuSelected, close, cameraList: panel === 'cameraList', openCameraList } } />
              }
            </MediaQuery>
          }
          <Map />
          {
            isNotOverview &&
            <MediaQuery maxWidth={MOBILE_BREAKPOINT_WIDTH}>
              { (matches) =>
                  (matches || forceMobile) &&
                  <BottomBar key='bottombar' { ...{ setPanel, openCameraPanel, close, openLabel, openFloorplan, panel } } />
              }
            </MediaQuery>
          }
          <Notification />
        </div>
        { isNotOverview && !forceMobile &&
          <MediaQuery minWidth={MOBILE_BREAKPOINT_WIDTH + 1}>
            <SideBar key='sidebar' />
          </MediaQuery>
        }
        {isNotOverview && <Modal />}
      </div>
    )
  }
}

export default connect(mapStateToProps, { zoomToSingleCameraAction })(Calculator)



// WEBPACK FOOTER //
// ./src/components/Calculator/index.js